import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { ASSUMPTIONS_TABS, INFLATION_TAB } from 'Consts/facet-plan';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { StyledTab, StyledTabs } from 'Components/AdvisorApp/Viewport/AssumptionsAdmin/AssumptionsAdmin/Content/AssumptionAdminLayout';
import State529ConfigByDateSection
  from 'Views/Page/Content/Templates/FacetPlanAssumptionSetTemplate/Content/State529ConfigByDateSection';
import AssumptionByDateSection from './AssumptionByDateSection';

const styles = () => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    flexDirection: 'column',
  },
});

const AssumptionAdminLayout = ({
  className,
  classes,
}) => {
  const [tabValue, setTabValue] = React.useState(INFLATION_TAB);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const getSelectedTab = () => {
    const [tab] = ASSUMPTIONS_TABS.filter(t => t.key === tabValue);
    return tab;
  };
  const { resource } = useMetaLayoutContext();


  const selectedTab = getSelectedTab();
  let assumptionsInCurrentTab = [];
  if (selectedTab.isState529Plan) {
    assumptionsInCurrentTab = resource.attr('stateSponsored529PlanConfigurations')
      .resources().list();
  } else {
    assumptionsInCurrentTab = resource.attr('assumptions')
      .resources().list()
      .filter(f => selectedTab.name.includes(f.attr('assumptionKey')));
  }

  return (
    <div
      className={classNames(classes.root, className)}
    >
      <StyledTabs
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleTabChange}
        aria-label="Assumption tabs"
        variant="scrollable"
        scrollButtons="on"
      >
        {ASSUMPTIONS_TABS.map(tab => {
          return !tab.isHidden && (
          <StyledTab
            key={tab.key}
            value={tab.value}
            label={tab.label}
            test={tab.test}
          />
          );
        })}
      </StyledTabs>
      {selectedTab.isState529Plan ? (
        <State529ConfigByDateSection stateConfigResources={assumptionsInCurrentTab} />
      ) : (
        <AssumptionByDateSection assumptionResources={assumptionsInCurrentTab} />
      )}
    </div>
  );
};

AssumptionAdminLayout.defaultProps = {
  className: '',
};

AssumptionAdminLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AssumptionAdminLayout);
